import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmailFileDetailsDTO } from 'src/app/shared/models/iCourrier/email/email-file-details';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParseEmailService {
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  parseEmailFile(file: File, fileExtension: string): Observable<EmailFileDetailsDTO> {
    const body = new FormData();
    body.append('file', file, file.name + '.' + fileExtension);

    return this.http.post<EmailFileDetailsDTO>(`${this.iCourrierURL}/Global/Tools/ParseEmailFile`, body);
  }

  parseEmailAttachments(mailID: number, fileID: number): Observable<EmailFileDetailsDTO> {
    return this.http.post<EmailFileDetailsDTO>(`${this.iCourrierURL}/Mails/${mailID}/Files/${fileID}/ParseEmail`, {});
  }
}
